import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {Face, VpnKey} from "@mui/icons-material";
import axios from "../../../utils/axiosConfig";
import { useSelector } from 'react-redux'
import { getOrgId } from '../../../reducer/dashboardSlice';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LoaderProcessing from '../../LoaderProcessing';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-prevent-tabpanel-${index}`}
      aria-labelledby={`scrollable-prevent-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-prevent-tab-${index}`,
    'aria-controls': `scrollable-prevent-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function ScrollableTabsButtonPrevent(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [errorMsg, setError] = React.useState("");
  const [password, setPassword] = React.useState(""); 
  const [confPassword, setConfPassword] = React.useState("");
  const [changePasswordError, setChangePasswordError] = React.useState("");
  const [changePasswordSuccess, setChangePasswordSuccess] = React.useState(false);
  const [changePasswordLoading, setChangePasswordLoading] = React.useState(false);
  const [oldPassword, setOldPassword] = React.useState("");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const validateField = (email, mobileNo) => {
    let status = {flag: false}, msg = '';
    // eslint-disable-next-line no-useless-escape
    let emailStatus = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    //msg += !emailStatus ? 'Invalid Email Address' : '';
    let mobileStatus = /^\d{10}$/.test(mobileNo);
    msg = (!emailStatus && !mobileStatus) ? 'Invalid Email Address, Invalid Mobile Number' : (!emailStatus ? 'Invalid Email Address' : (!mobileStatus ? 'Invalid Mobile Number' : ''));
    status.flag = (!emailStatus || !mobileStatus) ? true : false;
    status.msg = msg;
    return status;
  }
  const orgId = useSelector(getOrgId)
  const handleSubmit = (event) =>  {
    //alert('An essay was submitted: ' + this.state.value);
    event.preventDefault();
    setError('');
    
    let status = validateField( props.email, props.contactNo);
    

    if(status.flag){
        setError(status.msg);
    }else{
        axios.post('/dashboard/updateProfile',{
            headers: {
              'Access-Control-Allow-Origin': '*',
            },
            "firstName": props.firstName,
            "lastName": props.lastName,
            "contactNumber": props.contactNo,
            "userInfoID": props.userInfoId,
            // "email": props.email,
            "orgId": orgId,
        // eslint-disable-next-line unused-imports/no-unused-vars
        }).then(profileData => {
            
            setError('User data updated successfully');
        // eslint-disable-next-line unused-imports/no-unused-vars
        }).catch(error=>{
            
            setError('Something went wrong, Please try again later...');
        })
    }
    
  }

  const changePassword = (event) => {
      event.preventDefault();
      setChangePasswordError('');
      
      if (oldPassword !== password) {
        if(password === confPassword){
            let flag = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/.test(password);
            if(!flag){
              setChangePasswordError('*New Password must be minimum twelve characters, at least one uppercase letter, one lowercase letter, one number and one special character');
            }else{
              setChangePasswordError('');
              setChangePasswordLoading(true)
              axios.post('/dashboard/updatePassword',{
                  headers: {
                    'Access-Control-Allow-Origin': '*',
                  }, "oldPassword": oldPassword,
                "newPassword": password
              }).then(updateData => {
                  setChangePasswordLoading(false)
                  if(updateData.data.oldMatch === "FAIL"){
                      setChangePasswordError('Old password did not match...')
                  }else{
                      if(updateData.data.update === "FAIL"){
                          setChangePasswordError('Something went wrong, Please try again later...');
                      }else{
                          setChangePasswordSuccess(true)
                      }
                  }

              // eslint-disable-next-line unused-imports/no-unused-vars
              }).catch(error=>{
                  
                  setError('Something went wrong, Please try again later...');
              })
            }
        }else{
          setChangePasswordError('Password does not match')
        }
      } else {
        setChangePasswordError('New Password cannot be same as Old Password')
      }
  }

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          //variant="scrollable"
          //scrollButtons="off"
          aria-label="scrollable prevent tabs example"
          
          centered
        >
          <Tab icon={<Face style={{ color: "#fff" }} />} aria-label="profile" {...a11yProps(0)} />
          <Tab icon={<VpnKey style={{ color: "#fff" }} />} aria-label="password" {...a11yProps(1)} />
          
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
      <form className={classes.form} onSubmit={handleSubmit} noValidate>
                <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="firstName"
                label="First Name"
                name="firstName"
                autoComplete="firstName"
                value={props.firstName}
                autoFocus
                onChange= {(event) => props.setFirstName(event.target.value)}
                />
                <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="lastName"
                label="Last Name"
                name="lastName"
                autoComplete="lastName"
                value={props.lastName}
                autoFocus
                onChange= {(event) => props.setLastName(event.target.value)}
                />
                <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="phone"
                label="Contact No"
                name="phone"
                type="tel"
                //pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                value={props.contactNo}
                autoComplete="phone"
                autoFocus
                onChange= {(event) => props.setContactNo(event.target.value)}
                />
                <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="email"
                label="Email Address"
                type="email"
                id="email"
                value={props.email}
                autoComplete="email"
                disabled
                />
                <br/>
                <br/>
                <Typography style={{ fontSize: "12px"}}>{errorMsg}</Typography>
                <br/> 
                <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                >
                Update
                </Button>
                
            </form>
      </TabPanel>
      <TabPanel value={value} index={1}>
        {changePasswordSuccess ? (
          <div style={{ textAlign: "center" }}>
            <CheckCircleIcon style={{ fontSize: "80px", marginTop: "20px", color: "#4caf50" }} />
            <div style={{ marginTop: "20px", paddingLeft: "20px", color: "#4caf50" }}>
              Password changed successfully!
            </div>
          </div>
        ) : (
          <form className={classes.form} onSubmit={changePassword} noValidate>
          <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  required
                  id="oldPassword"
                  label="Old Password"
                  name="oldPassword"
                  autoComplete="oldPassword"
                  type="password"
                  autoFocus
                  onChange= {(event) => setOldPassword(event.target.value)}
                  />
          <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  required
                  id="password"
                  label="New Password"
                  name="password"
                  autoComplete="password"
                  type="password"
                  autoFocus
                  onChange= {(event) => setPassword(event.target.value)}
                  />
                  <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="confPassword"
                  label="Confirm New Password"
                  name="confPassword"
                  autoComplete="confPassword"
                  type="password"
                  autoFocus
                  onChange= {(event) => setConfPassword(event.target.value)}
                  />
                  <br />
                  <Typography style={{ fontSize: "15px", color: "#f00" }}>{changePasswordError}</Typography>
                  <br />
                  {changePasswordLoading ? (
                    <div className="loaderProcess" style={{ margin: "24px 0px 16px" }}>
                      <LoaderProcessing />
                    </div>
                  ) : (
                    <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    >
                    Change Password
                    </Button>
                  )}
          </form>
        )}
      </TabPanel>
      
    </div>
  );
}
